import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  creditTriggers: null,
  sourcingCredits: null,
  barterCredits: null,
  showCreditAnimation: false,
  sourcingMonthlyLimit: null,
  barterMonthlyLimit: null,
  sourcingLimitForSelectedBrand: null,
  barterCreditsForCollection: null,
  brandWiseSourcingCreditsList: [],
  collectionWiseBarterCreditsList: [],
  creditExpiryDate: "",
  brandSourcingCredits: null,
  brandSourcingLimit: null,
  sourcingHistory: [],
  brandSourcingHistory: [],
};

export const sourcingCreditsSlice = createSlice({
  name: "sourcingCredits",
  initialState: initialState,
  reducers: {
    updateCreditTriggers(state, action) {
      state.creditTriggers = action.payload;
    },
    updateCreditLimits(state, action) {
      state.sourcingCredits = action.payload.sourcingCredits;
      if (action.payload.showAnimation) state.showCreditAnimation = true;
      state.barterCredits = action.payload.barterCredits;
      state.sourcingMonthlyLimit = action.payload.sourcingLimit;
      state.barterMonthlyLimit = action.payload.barterMonthlyLimit;
      state.creditExpiryDate = action.payload.creditExpiryDate;
      state.brandSourcingCredits = action.payload.brandSourcingCredits;
      state.brandSourcingLimit = action.payload.brandSourcingLimit;
    },
    stopCreditAnimation(state, action) {
      state.showCreditAnimation = false;
    },
    updateSourcingBrandLimit(state, action) {
      state.sourcingLimitForSelectedBrand = action.payload;
      state.brandSourcingLimit = action.payload;
    },
    updateSourcingLimitForAllBrands(state, action) {
      state.brandWiseSourcingCreditsList = action.payload;
    },
    updateBarterLimitForAllCollections(state, action) {
      state.collectionWiseBarterCreditsList = action.payload;
    },
    updateBarterCreditsForCollection(state, action) {
      state.barterCreditsForCollection = action.payload;
    },
    resetAllSourcingLimits(state, action) {
      state.sourcingCredits = null;
      state.barterCredits = null;
      state.sourcingMonthlyLimit = null;
      state.showCreditAnimation = null;
      state.barterMonthlyLimit = null;
      state.sourcingLimitForSelectedBrand = null;
      state.barterCreditsForCollection = null;
    },
    updateSourcingHistory(state, action) {
      state.sourcingHistory = action.payload;
    },
    updateBrandSourcingHistory(state, action) {
      state.brandSourcingHistory = action.payload;
    },
  },
});

export const {
  updateCreditTriggers,
  updateCreditLimits,
  updateSourcingBrandLimit,
  updateSourcingLimitForAllBrands,
  updateBarterLimitForAllCollections,
  updateBarterCreditsForCollection,
  resetAllSourcingLimits,
  stopCreditAnimation,
  updateSourcingHistory,
  updateBrandSourcingHistory,
} = sourcingCreditsSlice.actions;
